<template>
    <div>
        <textarea class="form-control md-textarea" v-model="value" :name="name"/>
    </div>
</template>

<script>
    export default {
        name: "question-text",

        props: {
            name: {
                required: true
            }
        },

        data() {
            return {
                value: null
            }
        },

        watch: {
            value: function (newVal) {
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style scoped>

</style>
